<template>
<div  class="mcontent">
    <van-row
        type="flex"
        flex="1"
        rank='y'
          v-if="root.device!='phone'"
           :class="[root.device=='ipad'&&'mipad','fs16']"
    >
        <van-row
            type="flex"
            style="margin-left:1vw;height:3vw;"
            class="btn_row"
             >
            <van-col >
                <div class="type">生产部门</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col span="2">
                <div :class="cindex==0?'production_selected':'production'" @click="change(0)">本厂生产</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col span="2">
                <div :class="cindex==1?'production_selected':'production'" @click="change(1)">外协生产</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col span="2">
                <div :class="cindex==2?'production_selected':'production'" @click="change(2)">毛衣组</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col>
                <div class="type">下单方式</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col span="2">
                <div class="production_selected">大货</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col>
                <div class="type">状态</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col span="2">
                <div :class="cindex2==1?'production_selected':'production'" @click="change2(1)">全部</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col span="2">
                <div :class="cindex2==2?'production_selected':'production'" @click="change2(2)">延期款</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col span="2">
                <div :class="cindex2==3?'production_selected':'production'" @click="change2(3)">正常款</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col span="2">
                <div :class="cindex2==4?'production_selected':'production'" @click="change2(4)">未完工</div>
            </van-col>
        </van-row>
        
        <van-row
            flex='3'
            style="margin-top:-0.5vw">
            <div class='wrapper'>
                <cusbox txt="样品开发进度节点">
                    <van-row
                        type='flex'
                        style="height:100%;"
                        rank='y'
                        v-if="newProgressShow"
                    >
                        <van-row
                            type='flex'
                            flex='1'
                            class="myinfo"
                            v-for="(item, index) in datalist" :key="index">
                            <van-col class="left">
                                <van-row
                                    type='flex'
                                    class="touxiao" >
                                    <van-row
                                        type='flex'
                                        class="info_left"
                                        rank='y'
                                        flex='1'
                                        align='center'
                                    >
                                        <img :src="item.pics">
                                    </van-row>
                                    <van-row
                                        type='flex'
                                        class="info_right"
                                        flex='1'
                                        rank='y'
                                    >
                                        <van-row
                                            class="rowbtm"
                                            flex='1'
                                            type="flex"
                                        >生产部门：{{item.deptName}}</van-row>
                                        <van-row
                                            class="rowbtm"
                                            flex='1'
                                            type="flex"
                                        >下单方式：大货</van-row>
                                        <van-row
                                         class="rowbtm"
                                            flex='1'
                                            type="flex"
                                        >制单号：{{item.mspId}}</van-row>
                                        <van-row
                                            class="rowbtm"
                                            flex='1'
                                            type="flex"
                                        >上市日期:{{item.marketTime}}</van-row>
                                        <van-row
                                            class="rowbtm"
                                            flex='1'
                                            type="flex"
                                        >下单数量:{{item.total}}</van-row>
                                        <van-row
                                            class="rowbtm"
                                            flex='1'
                                            type="flex"
                                        >款号：{{item.bath}}/{{item.goodsno}}/{{item.colorId}}/{{item.color}}</van-row>
                                    </van-row>
                                </van-row>
                            </van-col>
                            <van-col
                                flex='1'
                                class="right">
                               <van-row type='flex' class="xline" >
                                   <van-row type='flex' flex='1' rank='y' v-for="(item2,index2) in item.nodeList" :key="index2" >
                                         <van-row flex='1' type='flex' justify='center'  style="overflow: hidden;">
                                            {{item2.nodeName}}
                                        </van-row>                                   
                                         <van-row flex='1' type='flex' justify='center'  align="center">
                                            {{item2.timeUp||'-'}}
                                        </van-row>                                        
                                         <van-row flex='1' type='flex' align='center' > 
                                            <div class="yuan_line" flex='1' v-if="index2>0"></div>  
                                            <div class="yuan_line2" flex='1' v-else></div>  
                                           <div class="yuan">-</div>    
                                           <div class="yuan_line" flex='1' v-if="index2<item.nodeList.length-1"></div>
                                           <div class="yuan_line2" flex='1' v-else></div>  
                                        </van-row>  
                                        <van-row flex='1' type='flex' justify='center'  align="center">                                       
                                          -
                                        </van-row>  
                                   </van-row>
                               </van-row>
                            </van-col>
                        </van-row>
                        <div class="sline"></div>
                    </van-row>
                    <dv-loading v-else>Loading...</dv-loading>
                </cusbox>
            </div>
        </van-row>

    </van-row>
      <mobile class="device_phone ppd notransform" v-else>
                  <van-row
            type="flex"
           
            class="btn_row"
             >
            <van-col >
                <div class="type">生产部门</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col >
                <div :class="cindex==0?'production_selected':'production'" @click="change(0)">本厂生产</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col >
                <div :class="cindex==1?'production_selected':'production'" @click="change(1)">外协生产</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col >
                <div :class="cindex==2?'production_selected':'production'" @click="change(2)">毛衣组</div>
            </van-col>     
            
        </van-row>
          <van-row
            type="flex"           
            class="btn_row"
          >
                      <van-col>
                <div class="type">下单方式</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col span="2">
                <div class="production_selected">大货</div>
            </van-col>
        
         </van-row>

                   <van-row
            type="flex"           
            class="btn_row"
          >
           <van-col>
                <div class="type">状态</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col >
                <div :class="cindex2==1?'production_selected':'production'" @click="change2(1)">全部</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col >
                <div :class="cindex2==2?'production_selected':'production'" @click="change2(2)">延期款</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col >
                <div :class="cindex2==3?'production_selected':'production'" @click="change2(3)">正常款</div>
            </van-col>
            <div style="width:1vw;"></div>
            <van-col >
                <div :class="cindex2==4?'production_selected':'production'" @click="change2(4)">未完工</div>
            </van-col>
         </van-row>

         <div class="moblieline" style="height:1050px">
                 <cusbox txt="样品开发进度节点">        

                    <layout v-if="newProgressShow" type="T_B"  class="jd_all"  v-for="(item,index) in datalist" :key="index">
                        <layout type="L_R" flex=1 style="margin-top:10px;height:100px;margin-bottom:20px">
                             <layout type="T_B" style="flex:none;padding:0px 10px;text-align:center">
                                    <img  style="width:90px;height:100px;display:block" :src="item.pics">
                                   
                             </layout>  
                            
                             <layout type="T_B">
                                  <div flex=1>生产部门：{{item.deptName}}</div>
                                  <div flex=1>下单方式：大货</div>
                                  <div flex=1>制单号：{{item.mspId}}</div>    
                                  <div flex=1>上市日期：{{item.marketTime}}</div>
                                  <div flex=1>下单数量：{{item.total}}</div>    
                                  <div flex=1>款号：{{item.bath}}/{{item.goodsno}}/{{item.colorId}}/{{item.color}}</div>                      
                             </layout>                          
                        </layout>
                        <!--  :class="Math.round(new Date(item2.date) / 1000)>Math.round(new Date(item2.enddate) / 1000)?'blue':''" -->
                         <div class="jd_line">
                             <layout type="T_B" v-for="(item2,index2) in item.nodeList" :key="index2"  style="margin-bottom:20px">
                                 <div class="jd_line_name">{{item2.nodeName}}</div>
                                 <div class="jd_line_time">{{item2.timeUp||'-'}}</div>
                                 <layout type="L_R" >
                                     <cell flex=1 v-if="index2>0"><div class="jd_line_left"></div></cell>
                                     <cell flex=1 v-else></cell>
                                    <div class="jd_yuan">-</div>
                                    <cell  flex=1 v-if="index2<item.nodeList.length-1"><div class="jd_line_right"></div></cell>
                                    <cell flex=1 v-else></cell>
                                 </layout>
                                 <div>-</div>
                             </layout>
                        </div>
                    </layout>
                    <dv-loading v-else>Loading...</dv-loading>
                </cusbox>
         </div>
      </mobile>
    </div>
</template>
<script>
import cell from "@/components/cuscom/cell.vue";
import layout from "@/components/cuscom/layout.vue";
import wrapper from "@/components/cuscom/wrapper.vue";
import cusbox from "@/components/vip/cusbox";
import itemlist from "@/components/cuscom/itemlist";
export default {
  components: { layout, wrapper, cusbox, itemlist,cell },
    inject:['root'],
  data() {
    return {
      api: this.$apis["production_schedule"],
      cindex:0,
      cindex2:1,
      datalist:[],
      list:[],
      newProgressShow:false
    };
  },
  mounted() {
    this.getdata();
  },
      beforeDestroy: function() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
  methods:{
      getdata(){        
          this.api.newProgress({state:this.cindex2,deptName:this.cindex==0?'本厂':this.cindex==1?'外协部':'毛衣组'}).then(res => {                
            this.list=res.data.list;
            const nlist=this.list.slice(0,3);
            this.list=nlist;
            this.newProgressShow = true
            this.doin();
          });
      },
      rundata(){
            this.list.push(this.list.shift())
            // this.designlist.shift()
            this.datalist=this.list.slice(0,3)
        },
        doin(){
            let that=this
                        if (this.timer) {
                clearInterval(this.timer);
            }
           this.timer= setInterval(function(){
               that.rundata()
            },3000)
        },
      change(val){
          this.cindex=val;
          this.newProgressShow = false
          this.getdata()
      },
      change2(val){
          this.cindex2=val
          this.newProgressShow = false
          this.getdata()
      },
      timestampToTime(timestamp) {
      var date = new Date(Number(timestamp)*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // var Y = date.getFullYear() + '-';
      // var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      // var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
      var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
      
      var strDate = h+m+s;
    return timestamp?strDate.split(' ')[0]:'-';//2020-07-30 01:05:54
    }
  }
};
</script>
<style lang="scss" scoped>
@import './device/phone.scss';
.sline {
  border-top: 2px solid #283a7f;
  width: 98%;
  margin: auto;
}
.mipad{

}
.myinfo {
  .left {
    width: 21vw;
    font-size: 14px;
    //   border:1px solid red;
    display: flex;
    color: #fff;
    .touxiao {
      width: 100%;
      height: 80%;
      margin: auto;
      .info_left {
        .hb {
          height: 0.25vw;
        }
        img {
          width: 80%;
        }
        width: 7vw;
        height: 100%;
      }
      .info_right {
        height: 100%;
        .rowbtm {
          align-items: flex-end;
        }
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    .xline {
      margin: auto;
      width: 95%;
      height: 80%;
      color: #fff;
      .yuan {
        border: 4px solid #ef4f7d;
        border-radius: 50%;
        width: 45px;
        height: 45px;
        color: #ef4f7d;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .blue {
        .yuan_line {
          border-top: 5px solid #48a0ee;
        }
        .yuan {
          border: 5px solid #48a0ee;
          color: #48a0ee;
        }
      }
      .yuan_line {
        border-top: 5px solid #ef4f7d;
      }
      .yuan_line2 {
      }
      .van-row {
        height: 100%;
      }
    }
  }
}
.type {
  color: #ffffff;
  display: flex;
  align-items: center;
  height: 2vw;
}
.production_selected {
  height: 2vw;
  width:100%;
  background: #4346d3;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  cursor: pointer;
  -moz-user-select: none;
-khtml-user-select: none;
user-select: none;
}
.production {
  height: 2vw;
  width:100%;
  border: 0.12vw solid #9698ff;
  color: #9698ff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -moz-user-select: none;
-khtml-user-select: none;
user-select: none;
}
  .notransform{
      .jd_all{
          color:#fff;
      }
        .jd_line{
            text-align: center;
            .jd_line_name{
                overflow: hidden;
            }
            &>div {width:20%;float: left;overflow: hidden;}
           
            .blue{
                .jd_yuan{ 
                      color: #48a0ee;
                      border: 2px solid #48a0ee;
                }
               .jd_line_left{
                    flex: 1;
                    border-top:1px solid #48a0ee;
                }
                .jd_line_right{
                    flex: 1;
                    border-top:1px solid #48a0ee;
                }
            }
               .jd_line_left{
                flex: 1;
                border-top:1px solid #ef4f7d;
            }
            .jd_line_right{
                flex: 1;
                border-top:1px solid #ef4f7d;
            }    
            .jd_yuan{             
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                    margin: 5px 0px;
                    color: #ef4f7d;
                     border: 2px solid #ef4f7d;
                    display: flex;
                    align-items: center;
                    justify-content: center;
            }
        }
  }
</style>


